<template>
  <transition name="fade">
    <div class="card-block add-car-block">
      <div class="add-car-inner">
        <div class="add-car-wrapper">
          <span>
            <svg svg-inline="" class="icon-car" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><path fill="#1D1D1B" d="M38.2 20.4c-.5-.1-1.1-.3-1.6-.3-.8-.1-2.1-.8-3.4-1.5-1-.5-2.1-1.1-3-1.4-1.2-.5-3.5-.5-5.2-.5-2.3 0-3.9.2-4.7.5-.8.3-2.2 1.5-4.3 3.5-2.5.3-4.2.7-5.2 1-1.7.6-2.8 1.7-3.1 2.6-.2.6-.3 1.3-.3 2.4v.2c0 1 .8 1.7 1.8 1.7H11c.2 1.7 1.7 3 3.5 3s3.2-1.3 3.5-3h12c.2 1.7 1.7 3 3.5 3s3.2-1.3 3.5-3l1.5-.1c1.1-.1 2.1-1.1 2-2.2l-.4-3.6c-.1-1.2-.8-2.1-1.9-2.3zm.2 7l-2.4.1v.5c0 1.4-1.1 2.5-2.5 2.5S31 29.4 31 28v-.5H17v.5c0 1.4-1.1 2.5-2.5 2.5S12 29.4 12 28v-.5H9.2c-.4 0-.8-.3-.8-.8v-.2c0-.9.1-1.6.2-2.1.2-.5 1-1.4 2.4-1.9 1-.3 2.7-.7 5.2-1h.2l.1-.1c2.5-2.5 3.6-3.2 4.1-3.4.7-.3 2.2-.4 4.3-.5 2.2 0 4 .2 4.8.5.8.3 1.9.9 2.9 1.4 1.4.8 2.8 1.5 3.7 1.6.5.1 1 .2 1.6.3.6.2 1.1.7 1.1 1.4l.4 3.6c.1.5-.4 1-1 1.1z"/></svg>
          </span>
          <p>Dodaj kolejny samochód do swojej listy</p>
        </div>
      </div>
      <div class="add-car-button">
        <standard-button
          @buttonClick="openModal()"
          class="fluid add-car-button"
          text="Dodaj samochód"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import StandardButton from '~/StandardButton';
import { mapActions } from 'vuex';

export default {
  components: {
    StandardButton,
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      setModalMode: 'modal/setModalMode',
      setModalStep: 'modal/setModalStep',
      setModalContent: 'modal/setContent',
      resetCarSpecs: 'car/resetCarSpecs',
    }),
    openModal() {
      this.resetCarSpecs();

      this.setModalMode('logged-in');

      this.setModalStep('first_step');

      this.setModalContent({
        title: 'Dodaj samochód',
        subtitle: 'Podaj parametry Twojego samochodu',
      });

      this.toggleModal();
    },
  },
};
</script>
